import { Inject, Injectable } from '@angular/core';

export interface BeforeInstallPromptEvent extends Event {
	readonly platforms: string[];

	readonly userChoice: Promise<{
		outcome: 'accepted' | 'dismissed';
		platform: string;
	}>;

	prompt(): Promise<void>;
}

@Injectable({
	providedIn: 'root'
})
export class PWAService {
	public static readonly NG1_INJECTION_NAME = 'pwaService' as const;
	private A2HSPrompt: BeforeInstallPromptEvent;

	/* @ngInject */
	constructor (
		@Inject('Window') private window: Window
	) {}

	public init () {
		// The serviceWorker will be null locally when not using https (https is required for serviceWorker).
		if (navigator == null || navigator.serviceWorker == null) return;
		// Install the service worker
		// For webpack to work, we cannot use $window. This is a pain for testing, but must be done.
		navigator.serviceWorker.register(/* webpackChunkName: "sw" */ new URL('./sw.ts', import.meta.url));
		// Setup add to home screen
		this.window.addEventListener('beforeinstallprompt', (e: BeforeInstallPromptEvent) => {
			e.preventDefault();
			this.setA2HSPrompt(e);
		});
	}

	public setA2HSPrompt (e: BeforeInstallPromptEvent) {
		this.A2HSPrompt = e;
	}

	public getA2HSPrompt () {
		return this.A2HSPrompt;
	}

	public launchPrompt () {
		return this.A2HSPrompt.prompt();
	}
}
